import { render, staticRenderFns } from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=template&id=6252bf40&"
import script from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportDesignOppositionList.vue?vue&type=style&index=0&id=6252bf40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports